<template>
    <!-- Modal EDIT branchparamteres -->
    <modal v-if="editModal" @close="editModalClose()" width="800px">
        <template slot="header">
            <h4 class="modal-title">Parâmetros de {{ editFieldsSelected }}</h4>
            <md-button
                class="md-simple md-just-icon md-round modal-default-button"
                @click="editModalClose()"
            >
                <md-icon>clear</md-icon>
            </md-button>
        </template>

        <template slot="body">
            <div class="md-layout">
                <div
                    class="md-layout-item md-layout md-size-100"
                    v-if="canUndoMany"
                >
                    <div class="md-layout-item md-size-100">
                        <h3>
                            Edição de loja(s) removida(s)
                        </h3>
                    </div>
                    <div class="md-layout-item md-size-100">
                        <div style="display: flex">
                            <span style="flex: 1">
                                Algumas lojas selecionadas foram removidas da
                                simulação. Ao confirmar a edição as mesmas serão
                                adicionadas novamente
                            </span>
                            <md-button @click="editModalClose()">
                                Retornar a listagem
                            </md-button>
                        </div>
                    </div>
                </div>

                <div
                    class="md-layout-item md-layout md-size-100 md-alignment-top-space-between"
                >
                    <!-- COMMON FIELDS -->
                    <div class="md-layout-item md-size-25 md-small-size-100">
                        <md-field>
                            <label>Preço de Venda</label>
                            <md-input v-model="editFields.price"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-25 md-small-size-100">
                        <md-field>
                            <label>Custo</label>
                            <md-input v-model="editFields.cost"></md-input>
                        </md-field>
                    </div>

                    <!-- SPECIFIC BRANCH FIELDS -->
                    <div
                        class="md-layout-item md-size-33 md-small-size-100"
                        v-if="
                            parameterType == 'branch' ||
                                parameterType == 'branch-parameter'
                        "
                    >
                        <md-field>
                            <label>Peças no Mostuário</label>
                            <md-input
                                v-model="editFields.showcase_items"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-33 md-small-size-100"
                        v-if="
                            parameterType == 'branch' ||
                                parameterType == 'branch-parameter'
                        "
                    >
                        <md-field>
                            <label>Peças na Pilha</label>
                            <md-input
                                v-model="editFields.stack_items"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-33 md-small-size-100"
                        v-if="
                            parameterType == 'branch' ||
                                parameterType == 'branch-parameter'
                        "
                    >
                        <md-field>
                            <label>Tempo de Cobertura</label>
                            <md-input v-model="editFields.coverage"></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-25 md-small-size-100"
                        v-if="
                            parameterType == 'branch' ||
                                parameterType == 'branch-parameter'
                        "
                    >
                        <md-field>
                            <label>TC Limite</label>
                            <md-input
                                v-model="editFields.coverage_max"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-25 md-small-size-100"
                        v-if="
                            (parameterType == 'branch' ||
                                parameterType == 'branch-parameter') &&
                                dcVisible
                        "
                    >
                        <md-field style="z-index: 9999 !important;">
                            <label>CD</label>
                            <md-select
                                v-model="editFields.dc"
                                name="dc"
                                id="dc"
                                value=""
                            >
                                <md-option
                                    v-for="dc in dcNames"
                                    v-bind:key="`dc-${dc.id}`"
                                    :value="dc.id"
                                >
                                    {{ dc.id }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-50 md-small-size-100"
                        v-if="parameterType == 'branch-parameter'"
                    >
                        <md-field>
                            <md-switch
                                v-model="editFields.guaranteed_stock"
                                class="md-secondary"
                            >
                                Estoque Garantido</md-switch
                            >
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-25 md-small-size-100"
                        v-if="parameterType == 'branch-parameter'"
                    >
                        <md-field style="z-index: 9999 !important;">
                            <label>Tipo de Venda</label>
                            <md-select
                                v-model="editFields.type_sale"
                                name="type_sale"
                                id="type_sale"
                                value=""
                            >
                                <md-option
                                    v-for="typeSale in typesSale"
                                    v-bind:key="`typeSale-${typeSale.id}`"
                                    :value="typeSale.id"
                                >
                                    {{ typeSale.description }}
                                </md-option>
                            </md-select>
                        </md-field>
                    </div>

                    <!-- SPECIFIC DC FIELDS -->
                    <div
                        class="md-layout-item md-size-25 md-small-size-100"
                        v-if="parameterType == 'dc'"
                    >
                        <md-field>
                            <label>TC Ciclo</label>
                            <md-input
                                v-model="editFields.coverage_period"
                            ></md-input>
                        </md-field>
                    </div>
                    <div
                        class="md-layout-item md-size-25 md-small-size-100"
                        v-if="parameterType == 'dc'"
                    >
                        <md-field>
                            <label>TC Segurança</label>
                            <md-input
                                v-model="editFields.coverage_safety"
                            ></md-input>
                        </md-field>
                    </div>
                </div>
            </div>
        </template>

        <template slot="footer">
            <md-button class="md-simple" @click="editModalClose()">
                Cancelar
            </md-button>
            <md-button class="md-primary" @click="editModalSubmit()">
                <i class="fas fa-spinner fa-spin" v-if="editModalLoading"></i>
                Confirmar
            </md-button>
        </template>
    </modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Modal } from '@/components'
import { BranchParameter as Model } from '@/models/branchparameter.model'

export default {
    props: {
        baseStore: { type: String, required: true },
        parameterType: {
            type: String,
            required: true,
            validator: value =>
                ['branch', 'dc', 'branch-parameter'].indexOf(value) !== -1
        },
        simulation: { type: Object, required: false },
        productId: { type: String, required: false }
    },
    components: {
        Modal
    },
    created() {
        this.readParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/read',
                ...arguments
            ])
        }
        this.updateParameters = function() {
            this.$store.dispatch.apply(null, [
                this.baseStore + '/update',
                ...arguments
            ])
        }
    },
    computed: {
        ...mapState({
            dcNames: state => state['branches'].dcNames,
            typesSale: state => state['branches'].typesSale
        }),

        editFieldsSelected() {
            let aux = this.fieldsSelected

            if (!aux || aux.length < 1) return ''

            return aux
                .map(a => a.branch_name)
                .reduce((acc, current, i) =>
                    i < this.listParameterSelected.length - 1
                        ? acc + ', ' + current
                        : acc + ' e ' + current
                )
        },

        canUndoMany() {
            return (
                this.selectedRows.filter(
                    a =>
                        (this.parameterType !== 'branch-parameter' &&
                            a.status != 'A') ||
                        (this.parameterType === 'branch-parameter' && !a.active)
                ).length > 0
            )
        }
    },
    data() {
        return {
            editModal: false,
            editModalLoading: false,

            editFields: new Model(),

            selectedRows: [],
            selectedBranches: [],

            dcVisible: false,

            // dynamic methods
            readParameters: null,
            updateParameters: null
        }
    },
    methods: {
        ...mapActions('branches', {
            readDcNames: 'readDcNamesById'
        }),
        ...mapActions('simulations', {
            createClone: 'createClone'
        }),

        // EDIT MODAL
        async editModalOpen(selectedRows) {
            if (selectedRows.length === 1) {
                this.editFields.price = selectedRows[0].price
                this.editFields.cost = selectedRows[0].cost
                this.editFields.showcase_items = selectedRows[0].showcase_items
                this.editFields.stack_items = selectedRows[0].stack_items
                this.editFields.coverage = selectedRows[0].coverage
                this.editFields.coverage_max = selectedRows[0].coverage_max
                this.editFields.dc = selectedRows[0].dc
                this.editFields.guaranteed_stock =
                    selectedRows[0].guaranteed_stock
                this.editFields.coverage_period =
                    selectedRows[0].coverage_period
                this.editFields.coverage_safety =
                    selectedRows[0].coverage_safety
                this.editFields.type_sale = selectedRows[0].type_sale
            }

            this.selectedRows = selectedRows

            if (this.parameterType !== 'branch-parameter')
                this.selectedBranches = selectedRows.map(a => a.branch)
            else
                this.selectedBranches = selectedRows.map(branch => ({
                    id: branch.id,
                    branch: branch.branch
                }))

            if (this.selectedBranches.length < 1) return
            else if (this.selectedBranches.length == 1) {
                this.dcVisible = true
                if (this.parameterType !== 'branch-parameter')
                    this.readDcNames(this.selectedBranches[0])
                else this.readDcNames(this.selectedBranches[0].branch)
            } else {
                this.dcVisible = false
                this.filterCD = null
            }

            this.editModal = true
        },
        editModalClose() {
            this.editFields = new Model()
            this.editModal = false
        },
        async editModalSubmit() {
            if (this.selectedBranches.length < 1) return

            this.editModalLoading = true

            if (this.simulation && !this.simulation.clone)
                await this.createClone(this.simulation.id)

            if (this.simulation)
                this.editFields.simulation = this.simulation.clone

            if (this.parameterType == 'branch')
                this.editFields.branch_ids = this.selectedBranches.reduce(
                    (acc, current, i) => acc + ',' + current
                )
            else if (this.parameterType == 'dc')
                this.editFields.dc_ids = this.selectedBranches.reduce(
                    (acc, current, i) => acc + ',' + current
                )
            else if (this.parameterType === 'branch-parameter') {
                this.editFields.ids = this.selectedBranches.map(
                    branch_param => branch_param.id
                )
            }

            await this.updateParameters(this.editFields)

            if (this.simulation) {
                await this.readParameters({
                    simulation: this.simulation.clone
                })
            } else {
                await this.readParameters({
                    ...(this.parameterType === 'branch-parameter' && {
                        product: this.productId
                    })
                })
            }

            this.editFields = new Model()
            this.editModalLoading = false
            this.editModal = false
        }
    }
}
</script>
